module.exports = __webpack_public_path__ + "img/basic_skinmask_202306.151cdb83.jpg";